import {Condition} from '../condition'

export const getSingleDefaults = (api) => ({
  selected_tickers: {
    tickers: []
  },
  conditions: [
    new Condition(api, {}),
    new Condition(api, {})
  ],
  custom_logic: 'AND'
})
